// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xero-config-page {
  padding: 16px;
  background: #fff;
  height: 100%;
  overflow-y: auto;
}

.xero-title {
  margin-bottom: 16px;
}

.xero-subtitle {
  margin-top: 20px;
  margin-bottom: 10px;
}

.xero-input {
  display: block;
  width: 100%;
  margin-bottom: 10px;
  padding: 8px;
}

.xero-block {
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.xero-btn {
  margin: 10px 0;
  padding: 8px 12px;
  cursor: pointer;
}

.xero-btn-danger {
  margin-top: 5px;
  background: red;
  color: white;
  padding: 6px 10px;
  cursor: pointer;
}

.xero-save-btn {
  margin-top: 20px;
  padding: 10px 14px;
  background: #1890ff;
  color: white;
  border: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/xero/company-setting/XeroConfiguration.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,oBAAA;EACA,6BAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AACF","sourcesContent":[".xero-config-page {\n  padding: 16px;\n  background: #fff;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.xero-title {\n  margin-bottom: 16px;\n}\n\n.xero-subtitle {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.xero-input {\n  display: block;\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 8px;\n}\n\n.xero-block {\n  margin-bottom: 12px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.xero-btn {\n  margin: 10px 0;\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.xero-btn-danger {\n  margin-top: 5px;\n  background: red;\n  color: white;\n  padding: 6px 10px;\n  cursor: pointer;\n}\n\n.xero-save-btn {\n  margin-top: 20px;\n  padding: 10px 14px;\n  background: #1890ff;\n  color: white;\n  border: none;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
